module.exports = __webpack_public_path__ + "media/Shopping.ce63168c.svg";